import React from 'react';
import { Skeleton } from '@mui/material';

import type { Column, Row } from './table.organism';

const skeletonCell = () => React.createElement(Skeleton, { variant: 'text', width: '75%' });

export function createSkeletonTable<T>(
  columns: Column<T>[],
  rowCount = 5
): { columns: Column<T>[]; rows: Row<T>[] } {
  return {
    columns: columns.map((col) => ({
      id: col.id,
      label: col.label,
      widthPercent: col.widthPercent,
      minWidth: col.minWidth,
      pinned: col.pinned,
      hideable: col.hideable,
      align: col.align,
      format: skeletonCell,
      noSort: true
    })),
    // Inert: empty row data must not reach onClick, and skeleton ids must not enter selection.
    rows: Array.from({ length: rowCount }, (_, i) => ({
      id: `skeleton-${i}`,
      data: {},
      disabled: true,
      disableSelect: true
    })) as Row<T>[]
  };
}
